import type { SkillSummary } from '@/features/rpa/recorder/types/skill-summary';

export function shouldPollUserWorkflows(
  summaries: readonly SkillSummary[] | undefined
): boolean {
  if (!summaries?.length) return false;
  return summaries.some((item) => item.status === 'processing');
}
